<template>
    <div id="app">
        <!-- 导航栏 -->
        <b-navbar toggleable="lg" type="dark" variant="dark">
            <div class="container">
                <b-navbar-brand href="#">
                    <h3>职业院校教师素质提高计划培训管理平台</h3>
                </b-navbar-brand>
                <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
                <b-collapse id="nav-collapse" is-nav v-if="$route.fullPath !== '/' && $route.fullPath !== '/regist' && $route.fullPath !== '/forget'">
                    <router-view name="menu"></router-view>
                    <!-- Right aligned nav items -->
                    <b-navbar-nav class="ml-auto">
                        <b-nav-item-dropdown right>
                            <!-- Using 'button-content' slot -->
                            <template v-slot:button-content>
                                <i class="fa fa-user"></i>
                                {{ $store.state.userInfo.userName }}
                            </template>
                            <b-dropdown-item href="#" @click.prevent="btnChangePassword_Click"><i class="fa fa-key"></i>
                                更改密码
                            </b-dropdown-item>
                            <b-dropdown-divider />
                            <!--                            <b-dropdown-item to="/messageManage"><i class="fas fa-info"></i> 系统消息</b-dropdown-item>-->
                            <!--                            <b-dropdown-divider />-->
                            <b-dropdown-item href="#" @click.prevent="btnSignOut_Click"><i class="fa fa-power-off"></i>
                                注销
                            </b-dropdown-item>
                        </b-nav-item-dropdown>
                    </b-navbar-nav>
                </b-collapse>

            </div>
        </b-navbar>

        <!-- 中间部分 -->
        <router-view></router-view>

        <!-- 页脚部分 -->
        <!-- 2024.10.16 去除 -->
        <!-- <div class="bg-light border-top pb-5 d-print-none">
            <div v-if="$route.fullPath === '/' || $route.fullPath === '/regist'" class="text-center my-4">
                <label class="explanStyle">|</label>
                <a :href="'/upload/file/辽宁省省培平台使用说明-参训教师、职业院校.pdf'">培训平台使用说明</a><br />
            </div>
            <p class="text-center">
                <router-link :to="{name: 'pdfView', params: {attFileId: '2c91d022-79d5df3e-0179-d6227a66-00cd'}}" target="_blank"><i class=" fa fa-home "></i> 帮助文档</router-link>
            </p>
        </div> -->

        <b-modal v-model="isChangePasswordDialogOpen" ref="changePasswordDialog"
                 title="用户登录密码修改"
                 ok-title="确定" cancel-title="取消" @ok="changePasswordDialog_OK"
                 :no-close-on-backdrop="true">
            <form>
                <div class="form-group row">
                    <label class="col-sm-3 col-form-label text-right" for="inputOldPassword">原始密码</label>
                    <div class="col-sm-8">
                        <input type="password" class="form-control" id="inputOldPassword" placeholder="原始密码"
                               v-model="changePasswordInfo.oldPassword">
                    </div>
                </div>
                <div class="form-group row">
                    <label for="inputPassword" class="col-sm-3 col-form-label text-right">新密码</label>
                    <div class="col-sm-8">
                        <input type="password" class="form-control" id="inputPassword" placeholder="新密码"
                               v-model="changePasswordInfo.password">
                    </div>
                </div>
                <div class="form-group row mb-0">
                    <label for="inputPassword2" class="col-sm-3 col-form-label text-right">确认新密码</label>
                    <div class="col-sm-8">
                        <input type="password" class="form-control" id="inputPassword2" placeholder="确认新密码"
                               v-model="changePasswordInfo.password2">
                    </div>
                </div>
            </form>
        </b-modal>
    </div>
</template>

<script>
import userApi from "@/utils/api/user";
export default {
    name: 'App',
    data: function () {
        return {
            changePasswordInfo: {
                userId: this.$store.state.userInfo.userId,
                password: '',
                password2: '',
                oldPassword: '',
                userType: this.$store.state.userType
            },
            isChangePasswordDialogOpen: false
        };
    },
    methods: {
        btnSignOut_Click() {
            this.$store.dispatch('signOutAction');
            this.$router.push('/');
        },
        btnChangePassword_Click() {
            this.changePasswordInfo = {
                userId: this.$store.state.userInfo.userId,
                password: '',
                password2: '',
                oldPassword: '',
                userType: this.$store.state.userType
            };
            this.isChangePasswordDialogOpen = true;
        },
        changePasswordDialog_OK(bvModalEvt) {
            bvModalEvt.preventDefault();
            if (this.changePasswordInfo.password !== this.changePasswordInfo.password2) {
                alert('请保证输入密码与确认密码相同！');
            }
            else {
                userApi.login.updateUserPassword(this.changePasswordInfo).then(res => {
                    if (res.data) {
                        alert('用户密码已修改');
                        this.$router.push("/");
                        this.isChangePasswordDialogOpen = false;
                    }
                    else {
                        alert('修改失败，请检查原始密码是否正确');
                    }
                });
            }
        }
    }
}
</script>


<style scoped>
.explanStyle {
    margin-left: 8px; 
    margin-right: 8px;
    height: 10px;
    color: #DFDCDC;
 }
  
</style>
